




































// Importing components
import LayoutMain from '@/layputs/LayoutMain.vue';
import TheWelcomeDiscountsMap from '@/components/welcome/TheWelcomeDiscountsMap.vue';
import TheWelcomeDonations from '@/components/welcome/TheWelcomeDonations.vue';
import TheWelcomeTags from '@/components/welcome/TheWelcomeTags.vue';
import TheWelcomeDescription from '@/components/welcome/TheWelcomeDescription.vue';
import TheWelcomeFood from '@/components/welcome/TheWelcomeFood.vue';
import TheWelcomeSteps from '@/components/welcome/TheWelcomeSteps.vue';
import TheWelcomeHeader from '@/components/welcome/TheWelcomeHeader.vue';
import CookieLaw from 'vue-cookie-law';
// Importing functions
import {getDateYear, IPLookUp} from '@/ts/helpers';
import {getRankings, getTags, handleScroll} from '@/ts/other/additional';

export default {
    name: 'PageWelcome',
    components: {
        TheWelcomeHeader,
        TheWelcomeSteps,
        TheWelcomeFood,
        TheWelcomeDescription,
        TheWelcomeTags,
        TheWelcomeDonations,
        TheWelcomeDiscountsMap,
        LayoutMain,
        CookieLaw,
    },
    props: {},
    data() {
        return {
            town: String(''),
            restaurants: Array(),
            tags: Array(),
            lat: Number(42.695653),
            lng: Number(23.306149),
            ekatte: String('68134'),
        };
    },
    methods: {
        getData() {
            return getDateYear();
        },
    },
    created() {
        window.addEventListener('scroll', handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', handleScroll);
    },
    mounted() {
        handleScroll();
        getRankings().then((response) => {
            this.restaurants = response['donations-ranklist'].splice(0, 3);
        });
        IPLookUp().then((response: any) => {
            const data = response.data.attributes;
            if (data.latitude !== '') { this.lat = Number(data.latitude); }
            if (data.longitude !== '') { this.lng = Number(data.longitude); }
            if (data.ekatte !== '') { this.ekatte = data.ekatte; }
            if (data.town_bg !== '') { this.town = data.town_bg; }
        });
        getTags().then((response) => {
            this.tags = response;
        });
    },
};
